import gql from 'graphql-tag';

export const ExportParticipants = gql`
  mutation ExportParticipants($organizationId: ID!, $request: GetPaginatedParticipantsRequest) {
    exportParticipants(organizationId: $organizationId, request: $request) {
      id
      name
      state
      createdOn
      startedOn
      completedOn
      response
    }
  }
`;
